import React from 'react';
import AppRoutes from './routes';
import { Toaster } from 'react-hot-toast';

const App = () => {
    return (
        <div className="App">
            <Toaster 
                position="top-right"
                reverseOrder={false}
                toastOptions={{
                style: {
                    borderRadius: '8px',
                    background: '#333',
                    color: '#fff',
                },
                }}
            />
            <AppRoutes />
        </div>
    );
};

export default App;
